import controller from './offers.controller';

export default {
  controller,
  template: require('./offers.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/offers/offers.component.ts